import React from "react";
import { LogoHeader } from "../../Components/Inicio/LogoHeaderComponent";
import { NavDesktop } from "../../Components/Inicio/NavDesktop";
import { NavMobile } from "../../Components/Inicio/NavMobile";
import { CrearUsuarioComponent } from "../../Components/Usuarios/CrearUsuarioComponent";
import { Footer } from "../../Components/Footer/FooterComponent";

export const CrearUsuario = (props) => {
    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <CrearUsuarioComponent I18n={props.I18n} />
            <Footer I18n={props.I18n} />
        </>
    )
}